import { call, put, takeEvery } from 'redux-saga/effects'

const apiUrl = `https://jsonplaceholder.typicode.com/users`;
function getApi() {
   return fetch(apiUrl, {
      method: 'PUT',
      headers: {
         'Content-Type': 'application/json',

      }
   }).then(response => response.json())
      .catch((error) => { throw error })
}

function* fetchUsers() {
   try {
      const users = yield call(getApi);
      // const 
      yield put({ type: 'GET_USERS_SUCCESS', users: users });
   } catch (e) {
      yield put({ type: 'GET_USERS_FAILED', message: e.message });
   }
}

function* userSaga() {
   yield takeEvery('GET_USERS_REQUESTED', fetchUsers);
}

export default userSaga;